import { ArrowRight, Tag } from "lucide-react";

export const formatNewsDate = (dateStr) =>
  new Date(dateStr).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });

export const FeaturedArticle = ({ article }) => (
  <article className="bg-[#111] border border-[#222] rounded-sm overflow-hidden card-hover mb-12" data-testid={`featured-article-${article.id}`}>
    <div className="grid lg:grid-cols-2">
      <div className="aspect-[16/10] lg:aspect-auto">
        <img src={article.image_url} alt={article.title} className="w-full h-full object-cover" />
      </div>
      <div className="p-8 md:p-12 flex flex-col justify-center">
        <div className="flex items-center gap-2 mb-4">
          <span className="bg-[#0D6B56] text-[#090B0C] text-xs font-bold px-2 py-1 rounded-sm uppercase">Featured</span>
          <span className="overline">{article.category.replace("_", " ")}</span>
        </div>
        <h2 className="font-display text-2xl md:text-3xl font-bold text-[#F2EDE4] mb-4">{article.title}</h2>
        <p className="text-[#F2EDE4]/40 mb-4">{article.excerpt}</p>
        <div className="flex items-center justify-between">
          <span className="text-sm text-[#F2EDE4]/30">By {article.author} • {formatNewsDate(article.created_at)}</span>
          <span className="text-[#F2EDE4] font-semibold text-sm inline-flex items-center gap-2">Read More <ArrowRight className="w-4 h-4" /></span>
        </div>
      </div>
    </div>
  </article>
);

export const ArticleCard = ({ article }) => (
  <article className="bg-[#111] border border-[#222] rounded-sm overflow-hidden card-hover group" data-testid={`article-${article.id}`}>
    <div className="aspect-[16/10] overflow-hidden">
      <img src={article.image_url} alt={article.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
    </div>
    <div className="p-6">
      <span className="overline">{article.category.replace("_", " ")}</span>
      <h3 className="font-display text-xl font-bold text-[#F2EDE4] mt-2 mb-2">{article.title}</h3>
      <p className="text-[#F2EDE4]/40 text-sm mb-4 line-clamp-2">{article.excerpt}</p>
      {article.tags?.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-4">
          {article.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="inline-flex items-center gap-1 text-xs text-[#F2EDE4]/30 bg-[#1D1F21] px-2 py-1 rounded-sm">
              <Tag className="w-3 h-3" /> {tag}
            </span>
          ))}
        </div>
      )}
      <div className="flex items-center justify-between pt-4 border-t border-[#1D1F21] text-xs text-[#F2EDE4]/30">
        <span>{formatNewsDate(article.created_at)}</span>
        <span>By {article.author}</span>
      </div>
    </div>
  </article>
);
